import BolliniVerdiActions from "../bolliniVerdi/BolliniVerdiActions";
import { action } from "../common/Action"
import ContrattiActions from "../contratti/ContrattiActions";
import { ImpiantiTermiciClient, ImpiantoData } from "../generated";
import InterventiActions from "../interventi/InterventiActions";
import ImpiantiClienteActions from "./ImpiantiClienteActions";

const service = new ImpiantiTermiciClient();

class ImpiantiTermiciActions {

    @action
    async getImpiantoTermico(idImpianto: number) {
        return (await service.getById(idImpianto))!;
    };

    @action
    async add(impianto: ImpiantoData) {
        const id = await service.addImpianto(impianto);
        ImpiantiClienteActions.getForCustomer(impianto.idCliente);
        return (await service.getById(id))!;
    }
    @action
    async update(impianto: ImpiantoData, idImpianto: number) {
        await service.updateImpianto(impianto, idImpianto);
        ImpiantiClienteActions.getForCustomer(impianto.idCliente);
        return (await service.getById(idImpianto))!;
    }

    @action
    async delete(idCliente: number, idImpianto: number) {
        const deleteOk = await service.deleteImpianto(idImpianto);
        ImpiantiClienteActions.getForCustomer(idCliente);
        if (deleteOk) {
            InterventiActions.getByCustomer(idCliente);
            BolliniVerdiActions.getByImpianto(idImpianto);
            ContrattiActions.getByImpianto(idImpianto);
        }
        return { impiantoId: idImpianto, idCliente, deleteOk };
    }

    @action
    async getApparecchioCategories() {
        return (await service.getApparecchiCateogories())!
    };


}
export default new ImpiantiTermiciActions();